/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {IBuffaloWinRatioConfig, WinterHoardGameConfig} from "../WinterHoardGameConfig";
import {SoundPlayer} from "../sound/SoundPlayer";
import {StateMatrix} from "../utils/StateMatrix";
import {SymbolUtil} from "../utils/SymbolUtil";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";

export class WinEnd implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _hasWin:boolean;
    private _tl:TimelineLite;
    private _symbolStates:StateMatrix<string>;
    private _gameData:ParsedGameData;
    private _exitingFs:boolean;
    private _addFreespins:number = 0;
    private _bData:WinterHoardParsedGameData;


    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
        this._hasWin = data.singleWin > 0;
        this._bData = <WinterHoardParsedGameData> data;
        this._addFreespins = this._bData.addFreespins | 0;

        this._gameData = <ParsedGameData>data;
        this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(
            <IBetLineWinData[]>this._gameData.betWins!,
            GameConfig.instance.SYMBOL_STATES.noWin!.keyword,
            GameConfig.instance.SYMBOL_STATES.win!.keyword);

        this._exitingFs = ((data.mode === "FREESPIN_TRANSFORM" && data.nextMode === "NORMAL")
        || (data.mode === "FREESPIN_MULTIPLIER" && data.nextMode === "NORMAL")
        || (data.mode === "FREESPIN_COMBINED" && data.nextMode === "NORMAL"));
    }

    public getNoWinSymbolAnimations():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        //tl.add(() => {}, 0.1);
            for (let reelId = 0; reelId < 5; reelId++) {
                const reelCoords: [number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, GameConfig.instance.SYMBOL_STATES.noWin!.keyword);
                for (let coords of reelCoords) {
                    if(!(Reels.getSymbol(coords[0], coords[1])!.symName === "S")){
                        tl.add(this.getSymbolAnimation(coords[0], coords[1], GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
                    }
                }

                tl.add(this.getSymbolAnimation(reelId, -1, GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
                tl.add(this.getSymbolAnimation(reelId, 4, GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
            }


        return tl;
    }

    private getSymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                //setStack : true,
                fadeInDuration : 0.0
            })!;

            tl.add([
                () => this.sortSymbolDepthToTop(symbol),
                symbolAnimation
            ]);
        }
        return tl;
    }

    protected sortSymbolDepthToTop(symbol:StateReelSymbol):void {
        if(symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }

    public getAnimation(data:ParsedGameData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        this._tl = new TimelineLite();


        if(this._gameData.mode !== "NORMAL") {
            this._tl.add(this.getNoWinSymbolAnimations());
        }

        if(data.isBigWin) {
            this._tl.add([
                WinterHoardGameModuleConfig.bigWinView.playEndingAnimation(),
                () => SoundPlayer.playEffect(WinterHoardSoundConfig.BIG_WIN_END),
                WinterHoardGameModuleConfig.countUpView.end(data.singleWin, 1, 0.2),
                WinterHoardGameModuleConfig.winTextView.end((<IBuffaloWinRatioConfig>data.currentWinRatioConfig)!, 1, 0.2),
            ], 0);
        }
        else {
            this._tl.add(WinterHoardGameModuleConfig.countUpView.end(data.singleWin, 1, 0.2));
        }

        if(this._exitingFs) {
            //console.log("TL DELAY ADD");
            this._tl.add(() => {}, "+=1.0");
        }

        return this._tl;
    }

    public abort(isActive:boolean, data:ParsedGameData):Timeline | null {
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
        }
        else {
            if(this._hasWin) {
                this.getAnimation(data);
            }
        }
        return null;
    }
}